import { useRef, useState } from "react";
import axios from "axios";
import {
  Button,
  CircularProgress,
  Menu,
  MenuItem
} from "@material-ui/core";
import { Publish } from "@material-ui/icons";
import VisuallyHiddenInput from "./visually-hidden-input";
import { useSnackbar } from "notistack";

const DEV_BASE_URL = "http://localhost:8080";
const PROD_BASE_URL = "https://portal.macgroupus.com/api";

function DataImportButton({ name, buttonText = "Upload File", onDataImport, buttonProps, ...restProps }) {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isImportLoading, setIsImportLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const fileInputRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  function downloadTemplate(params) {
    const queryString = Object.keys(params)
      .filter(key => params[key] != null)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
    window.open(`${PROD_BASE_URL}/generateDataImportTemplate/${name}?${queryString}`, '_blank');
  }

  async function upload(e) {
    if (!e.target.files?.length) return;

    let formData = new FormData();
    Object.keys(restProps).forEach(key => {
      if (restProps[key] != null) {
        formData.append(key, restProps[key]);
      }
    });

    formData.append('file', e.target.files[0]);
    setIsImportLoading(true);
    setUploadProgress(0);

    try {
      const response = await axios.post(`/processDataImport/${name}`, formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        }
      });
      await onDataImport(response.data);
    } catch (e) {
      console.error(e);
      enqueueSnackbar(`Error uploading file. Please review file for errors and try again or contact support.`, {variant: 'error'});
    } finally {
      setAnchorEl(null);
      setIsImportLoading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  }

  return (
    <>
      <Button
        variant="outlined"
        startIcon={isImportLoading ? <CircularProgress variant='determinate' value={uploadProgress} size={16}/> :
          <Publish/>}
        {...buttonProps}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {buttonText}
      </Button>
      <VisuallyHiddenInput ref={fileInputRef} id={name} onChange={(e) => upload(e)} type="file"/>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={(_) => downloadTemplate(restProps)}>
          Download Template
        </MenuItem>
        <MenuItem
          onClick={(_) => fileInputRef.current?.click()}
        >
          Upload Data
        </MenuItem>
      </Menu>
    </>
  );
}

export default DataImportButton;
